<template>
  <div class="tabs-wrapper">
    <div
      class="tab"
      :class="activeTab === 'assets' ? 'active' : ''"
      @click="chooseTab('assets')"
    >
      Assets
    </div>
    <div
      class="tab"
      :class="activeTab === 'on-market' ? 'active' : ''"
      @click="chooseTab('on-market')"
    >
      On Market
    </div>
    <!-- <div
      class="tab"
      :class="activeTab === 'created' ? 'active' : ''"
      @click="chooseTab('created')"
    >
      Created
    </div>
    <div
      class="tab"
      :class="activeTab === 'favorited' ? 'active' : ''"
      @click="chooseTab('favorited')"
    >
      Favorited
    </div> -->
  </div>
</template>

<script>
export default {
  props: ['activeTab'],
  methods: {
    chooseTab(tab) {
      this.$emit('CHOOSE_TAB', tab);
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@/assets/style/variables.scss';

.tabs-wrapper {
  width: 584px;
  margin: 0 auto 40px;
  display: flex;
  justify-content: center;
  font-family: Inter;
  font-size: 20px;
  font-weight: 500;
  color: #798392;
  .tab {
    cursor: pointer;
    padding: 9px 24px;
    &.active {
      color: #ffffff;
      background-color: #5b6ef5;
      border-radius: 25px;
    }
  }
}

@media screen and (max-width: $breakpoint-mobile) {
  .tabs-wrapper {
    width: 100%;
    justify-content: center;
    font-size: 13px;
    .tab {
      padding: 9px 16px;
    }
  }
}
</style>
